/** @format */

import React, { useState } from 'react'
import { _$, Card } from '@king-design/react'
import styled from 'styled-components'
import MonitorCrumb from 'src/components/MonitorCrumb'
import { initSearch } from '../components/constant'
import { ServiceOverviewSearchProps } from '../components/typescript'
import HeaderFilter from '../components/HeaderFilter'
import TraceContainer from './container'
import useNavRegion from 'src/hooks/useNavRegion'
const TraceAnalysis: React.FC<{ className?: string }> = ({ className }) => {
  const [headerSearch, setHeaderSearch] = useState<ServiceOverviewSearchProps>(initSearch())
  const region = useNavRegion()
  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: _$('AI可观测') }, { title: _$('Trace分析') }]} />
      <Card title={_$('Trace分析')}>
        <HeaderFilter value={headerSearch} onChange={setHeaderSearch} showAggregate={false} />
        <TraceContainer region={region} headerSearch={headerSearch} />
      </Card>
    </div>
  )
}

export default styled(TraceAnalysis)`
  padding: 0 16px;
`
